import backendHttpClient from '@services/_httpClient/backend.http-client';

import type { CreateTaskPayload } from './dtos/create.dto';
import type { GetAllTasksParams } from './dtos/getAll.dto';
import type { UpdateTaskDto, UpdateTaskPayload } from './dtos/update.dto';
import type { TaskRepository } from './repository';
import type { CreateTaskOutput, CreateTaskResponse } from './types/create.type';
import type {
  GetAllTasksOutput,
  GetAllTasksResponse,
} from './types/getAll.type';
import type {
  GetTaskByIdOutput,
  GetTaskByIdResponse,
} from './types/getById.type';
import type { UpdateTaskOutput, UpdateTaskResponse } from './types/update.type';

class TaskService implements TaskRepository {
  public async create(payload: CreateTaskPayload): Promise<CreateTaskOutput> {
    const { data } = await backendHttpClient.post<
      CreateTaskResponse,
      CreateTaskPayload
    >({
      path: 'tasks',
      body: {
        handlerId: payload.handlerId,
        dueDate: payload.dueDate,
        parentId: payload.parentId,
        level: payload.level,
        type: payload.type,
      },
    });

    return {
      task: data.task,
    };
  }

  public async getAll(params: GetAllTasksParams): Promise<GetAllTasksOutput> {
    const { data } = await backendHttpClient.get<
      GetAllTasksResponse,
      GetAllTasksParams
    >({
      path: 'tasks',
      params: {
        dueDateStatus: params.dueDateStatus,
        showAll: params.showAll,
      },
    });

    return {
      counts: data.counts,
      list: data.list,
    };
  }

  public async getById(id: string): Promise<GetTaskByIdOutput> {
    const { data } = await backendHttpClient.get<GetTaskByIdResponse>({
      path: `tasks/${id}`,
    });

    return { task: data.task };
  }

  public async update(payload: UpdateTaskPayload): Promise<UpdateTaskOutput> {
    const { data } = await backendHttpClient.put<
      UpdateTaskResponse,
      UpdateTaskDto
    >({
      path: `tasks/${payload.id}`,
      body: {
        dueDate: payload.dueDate,
        handlerId: payload.handlerId,
      },
    });

    return {
      task: data.task,
    };
  }

  public async complete(id: string): Promise<void> {
    await backendHttpClient.patch({
      path: `tasks/${id}/complete`,
    });
  }

  public async cancel(id: string): Promise<void> {
    await backendHttpClient.patch({
      path: `tasks/${id}/cancel`,
    });
  }
}

export const taskService = new TaskService();
